import { IDisposable } from './Disposable';
import { Resource } from './Resource';

export abstract class DisposableResource<T extends IDisposable> extends Resource<T> {
  protected constructor(id: string) {
    super(id);
  }

  destroy(): void {
    if (this.data) {
      this.data.dispose();
    }

    super.destroy();
  }
}
